<ion-content [fullscreen]="true" *transloco="let t; read: 'registerPage'">
    <ion-grid class="grid">
        <div class="login-wrapper">
            <div class="wrap">

                <div class="wrapper-header" >

                    <div class="language-switcher">

                        <app-language-switcher [showListStyle]="true"></app-language-switcher>
                    </div>

                    <div class="arrow-back" [routerLink]="'/login'" *ngIf="step1Register  && !step2Test && !step3Group">

                        <svg fill="#D7F3C2" height="39px" width="39px" version="1.1" id="Layer_1"
                             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                             viewBox="0 0 476.213 476.213" xml:space="preserve" stroke="#D7F3C2"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"> <polygon
                                points="476.213,223.107 57.427,223.107 151.82,128.713 130.607,107.5 0,238.106 130.607,368.714 151.82,347.5 57.427,253.107 476.213,253.107 "></polygon> </g></svg>
                    </div>

                    <a [routerLink]="'/login'">
                        <img class="login-logo" src="assets/images/icons/login-logo.svg" alt="login logo">
                    </a>
                </div>

                <div class="login-form">

                    <ion-grid class="step-grid">
                        <ion-row class="steps-wrapper">
                            <ion-col class="step" [ngClass]="{'active': step1Register}">
                                <div class="inner-step">
                                    <span *ngIf="!step1RegisterDone">1.</span>
                                    <img src="assets/images/icons/done_green.svg" *ngIf="step1RegisterDone" alt="done">
                                    {{ t('step1') }}
                                </div>
                            </ion-col>
                            <ion-col class="step" [ngClass]="{'active': step2Test}">
                                <div class="inner-step">
                                    <span *ngIf="!step2TestDone">2.</span>
                                    <img src="assets/images/icons/done_green.svg" *ngIf="step2TestDone" alt="done">
                                    {{ t('step2') }}
                                </div>
                            </ion-col>
                            <ion-col class="step" [ngClass]="{'active': step3Group}">
                                <div class="inner-step">
                                    <span *ngIf="!step3GroupDone">3.</span>
                                    <img src="assets/images/icons/done_green.svg" *ngIf="step3GroupDone" alt="done">
                                    {{ t('step3') }}
                                </div>
                            </ion-col>
                        </ion-row>
                    </ion-grid>

                    <div *ngIf="step1Register && !step1RegisterDone">

                        <div class="title">
                            {{ t('studentInfo') }}
                        </div>

                        <div class="teaser" [innerHTML]="t('teaser')"></div>

                        <form (submit)="onSubmit()" [formGroup]="registerForm" class="register-form login">

                            <div class="form-group">

                                <ion-input class="input-field" inputmode="text"
                                           [attr.aria-label]="t('name')"
                                           placeholder="{{  t('name') }}"
                                           labelPlacement="stacked"
                                           formControlName="studentFirstName"
                                           label-placement="floating" fill="outline"
                                           (ionBlur)="removeErrorBorder('studentFirstName')"
                                           [ngClass]="{'invalid-border': registerForm.get('studentFirstName')?.hasError('cyrillicCharacters')  && registerForm.get('studentFirstName')?.touched}">
                                </ion-input>


                                <small class="error-message"
                                       *ngIf="registerForm.get('studentFirstName')?.hasError('cyrillicCharacters') && registerForm.get('studentFirstName')?.touched">

                                    {{ t('errorName') }}

                                </small>

                                <ion-input class="input-field" inputmode="text"
                                           [attr.aria-label]="t('lastName')"
                                           placeholder="{{ t('lastName') }}"
                                           labelPlacement="stacked"
                                           formControlName="studentLastName"
                                           label-placement="floating" fill="outline"
                                           (ionBlur)="removeErrorBorder('studentLastName')"
                                           [ngClass]="{'invalid-border': registerForm.get('studentLastName')?.hasError('cyrillicCharacters')  && registerForm.get('studentLastName')?.touched}">
                                </ion-input>

                                <small class="error-message"
                                       *ngIf="registerForm.get('studentLastName')?.hasError('cyrillicCharacters') && registerForm.get('studentLastName')?.touched">

                                    {{ t('errorSecondName') }}
                                </small>

                                <div ngForm="telInputBlock" class="form-tel" #telInputBlockStudent>
                                    <intl-tel-input
                                        #telInputStudentElement
                                        name="studentPhone"
                                        [cssClass]="'form-group-control phone-student '"
                                        [labelCssClass]="'col-sm-2 col-form-label'"
                                        [required]="true"
                                        [options]="{
                                            preferredCountries: ['ua'],
                                            initialCountry:'ua',
                                            separateDialCode:true,
                                          }"
                                        [(E164PhoneNumber)]="this.phone"
                                        (input)="isEnterNumberIsDeleted = false"

                                    ></intl-tel-input>
                                </div>
                                <small class="error-message"
                                       *ngIf="this.isEnterNumberIsDeleted">

                                    {{ t('errorPhoneNumber') }}
                                </small>

                                <div class="input-field">
                                    <div class="label"> {{ t('sex') }}</div>

                                    <ion-radio-group formControlName="studentGender" class="gender-wrapper"
                                                     (click)="removeInvalidBorder($event)">
                                        <ion-item class="gender gender-2">
                                            <ion-radio slot="start" labelPlacement="end" mode="android"
                                                       value="{{this.GENDER_MALE}}">{{ t('male') }}
                                            </ion-radio>
                                        </ion-item>

                                        <ion-item class="gender gender-2">

                                            <ion-radio slot="start" labelPlacement="end" mode="android"
                                                       value="{{this.GENDER_FEMALE}}">{{ t('female') }}
                                            </ion-radio>
                                        </ion-item>
                                    </ion-radio-group>
                                </div>

                                <div class="input-field">
                                    <div class="label"> {{ t('birthday') }}</div>
                                    <div class="birthday-input" [formGroup]="registerForm.controls.birthdayItem">
                                        <!--                                    <ion-input type="number"-->
                                        <!--                                               class="input-field birthday" inputmode="numeric" label="ДД"-->
                                        <!--                                               formControlName="day"-->
                                        <!--                                               label-placement="floating" fill="outline"-->
                                        <!--                                              ></ion-input>-->

                                        <ion-item id="day" class="input-field school-class birthday  no-ripple"
                                                  [ngClass]="{'invalid-border':  this.registerForm.get('birthdayItem.day')?.hasError('required')  && registerForm.get('birthdayItem.day')?.touched}">

                                            <ion-select class="school-class-alert birthday"
                                                        formControlName="day"
                                                        interface="popover"
                                                        [attr.aria-label]="t('dd')"
                                                        placeholder=" {{ t('dd') }} ">

                                                <ion-select-option *ngFor="let day of days" [value]="day">{{ day }}
                                                </ion-select-option>
                                            </ion-select>
                                        </ion-item>

                                        <!--                                    <ion-input type="number" class="input-field birthday" inputmode="numeric" label="ММ"-->
                                        <!--                                               formControlName="month"-->
                                        <!--                                               label-placement="floating" fill="outline"></ion-input>-->
                                        <ion-item id="month" class="input-field school-class birthday  no-ripple"
                                                  [ngClass]="{'invalid-border':  this.registerForm.get('birthdayItem.month')?.hasError('required')  && registerForm.get('birthdayItem.month')?.touched}"
                                        >
                                            <ion-select class="school-class-alert birthday"
                                                        [attr.aria-label]="t('mm')"
                                                        placeholder="{{ t('mm') }}"
                                                        formControlName="month"
                                                        interface="popover">
                                                <ion-select-option *ngFor="let month of months"
                                                                   [value]="month.value">
                                                    {{ month.title | transloco }}
                                                </ion-select-option>
                                            </ion-select>
                                        </ion-item>

                                        <!--                                    <ion-input type="number" class="input-field birthday" inputmode="numeric"-->
                                        <!--                                               label="РІК" formControlName="year"-->
                                        <!--                                               label-placement="floating" fill="outline"></ion-input>-->

                                        <ion-item id="year" class="input-field school-class birthday  no-ripple"
                                                  [ngClass]="{'invalid-border':  this.registerForm.get('birthdayItem.year')?.hasError('required')  && registerForm.get('birthdayItem.year')?.touched}"
                                        >
                                            <ion-select class="school-class-alert birthday"
                                                        [attr.aria-label]="t('year')"
                                                        placeholder="{{ t('year') }}"
                                                        interface="popover"
                                                        formControlName="year">
                                                <ion-select-option *ngFor="let year of years"
                                                                   [value]="year">{{ year }}
                                                </ion-select-option>
                                            </ion-select>
                                        </ion-item>


                                        <!--                                    <ion-datetime presentation="date" [formGroup]="registerForm.controls.birthdayItem"></ion-datetime>-->
                                    </div>
                                </div>

                                <div *ngIf="showNoteNextClassMessage" class="note ion-margin-top  ion-margin-bottom"
                                     style="color: #811F20;">
                                    {{ t('nextClassConfirmMessage') }}
                                </div>
                                <ion-item id="studentSchoolClass" class="input-field school-class no-ripple"
                                          [ngClass]="{'invalid-border':  this.registerForm.get('studentSchoolClass')?.hasError('required')  && registerForm.get('studentSchoolClass')?.touched}"
                                >
                                    <ion-select class="school-class-alert"
                                                [attr.aria-label]="t('schoolGrade')"
                                                placeholder="{{t('schoolGrade')}} "
                                                formControlName="studentSchoolClass" cancel-text="Скасувати"
                                                interface="popover"
                                                side="top"
                                    >
                                        <ion-select-option *ngFor="let item of SCHOOL_CLASS"
                                                           value="{{item.value}}">{{ (item.value ===13 || item.value === 12) ? (item.title | transloco) : item.title }}
                                        </ion-select-option>

                                    </ion-select>
                                </ion-item>


                                <div class="title" [ngClass]="{'with-cursor':allowParentInfo}"
                                     (click)="allowParentInfo? showParentInfo= !showParentInfo : null">
                                    {{ t('parentInfo') }}

                                    <div class="arrow" [ngClass]="{'up': !showParentInfo }"></div>
                                </div>

                                <div *ngIf="allowParentInfo && showParentInfo">

                                    <ion-input class="input-field" inputmode="text"
                                               [attr.aria-label]="t('name')"
                                               placeholder="{{ t('name') }}"
                                               labelPlacement="stacked"
                                               formControlName="parentName"
                                               label-placement="floating" fill="outline"
                                               [ngClass]="{'invalid-border':  (this.registerForm.get('parentName')?.hasError('required') || this.registerForm.get('parentName')?.hasError('cyrillicCharacters') ) && registerForm.get('parentName')?.touched}"
                                    ></ion-input>

                                    <small class="error-message"
                                           *ngIf="registerForm.get('parentName')?.hasError('cyrillicCharacters') && registerForm.get('parentName')?.touched">
                                        {{ t('errorName') }}

                                    </small>

                                    <div ngForm="telInputBlock" class="form-tel parentPhone" #telInputBlockParent>
                                        <intl-tel-input
                                            #telInputParentElement
                                            name="parentPhone"
                                            [cssClass]="'form-group-control phone'"
                                            [labelCssClass]="'col-sm-2 col-form-label'"
                                            [required]="true"
                                            [options]="{
                    preferredCountries: ['ua'],
                    initialCountry:'ua',
                    separateDialCode: true,
                  }"
                                            [(E164PhoneNumber)]="parentPhone"
                                            (input)="onPhoneInput($event)"
                                        ></intl-tel-input>


                                    </div>


                                    <ion-input class="input-field" inputmode="email"
                                               aria-label="Email *" placeholder="Email *" labelPlacement="stacked"
                                               formControlName="parentEmail"
                                               label-placement="floating" fill="outline"
                                               [ngClass]="{'invalid-border':  this.registerForm.get('parentEmail')?.hasError('required')  && registerForm.get('parentEmail')?.touched}"
                                    ></ion-input>

                                </div>


                                <div class="promo-code "
                                     [ngStyle]="{'border-bottom': enterPromoCode ? 'none' : '1px solid #F2F2F2'}">

                                    <div class="title-code" (click)="enterPromoCode = !enterPromoCode">
                                        <img
                                            [src]="enterPromoCode ? 'assets/images/icons/minus_dark.svg' : 'assets/images/icons/plus_dark.svg'"
                                            alt="add">
                                        {{ t('addPromoCode') }}
                                    </div>

                                    <ion-input *ngIf="enterPromoCode" class="input-field" inputmode="text"
                                               [attr.aria-label]="t('promocode')"
                                               placeholder="{{ t('promocode') }}"
                                               labelPlacement="stacked"
                                               formControlName="promocode" label-placement="floating"
                                               fill="outline"
                                               [ngClass]="{'invalid-border':this.promoCodeIsNotValid}"
                                    ></ion-input>

                                    <small class="error-message"
                                           *ngIf="registerForm.get('promocode')?.hasError('maxlength') && registerForm.get('promocode')?.touched">

                                        {{ t('errorPromo') }}
                                    </small>

                                    <small class="error-message"
                                           *ngIf="this.promoCodeIsNotValid">
                                        {{ this.promoCodeErrorMessage }}
                                    </small>


                                </div>


                                <div class="agreement">

                                    <ion-checkbox name="agreement" labelPlacement="end"
                                                  value="1" (click)="acceptRules()">{{ t('agreement') }}
                                    </ion-checkbox>

                                </div>

                                <button type="submit" class="btn green-btn"
                                        [disabled]="!canSubmit || isEnterNumberIsDeleted"
                                        [ngClass]="{'disable' : this.isEnterNumberIsDeleted || !canSubmit}">{{ t('saveData') }}
                                </button>


                            </div>

                        </form>

                    </div>

                    <div *ngIf="step2Test && !step2TestDone" class="test-wrapper">

                        <div class="teaser">{{ t('test') }}</div>
                        <div class="upper-teaser">{{ t('testTeaser') }}</div>


                        <button type="submit" class="btn green-btn" (click)="startTest()">{{ t('testStart') }}</button>

                        <button type="submit" class="btn green-btn"
                                (click)="presentSharePopover($event, true)">{{ t('testSend') }}
                        </button>


                        <button *ngIf="this.refLink" type="submit" class="btn green-border-btn"
                                (click)="presentSharePopover($event)">
                            {{ t('testInvite') }}
                            <img src="assets/images/icons/share_green.svg" alt="to share">

                        </button>

                    </div>

                </div>


            </div>


        </div>


    </ion-grid>

    <app-footer></app-footer>

</ion-content>

<app-chats></app-chats>
